import * as React from "react";
import * as ReactDOM from "react-dom";
import { IOWidget, mk_widget, Widget } from "../widget";

interface ModalProps<i,o> {
  modal_root:HTMLElement
  input:i
  inner_widget:IOWidget<i,o>
  on_done:(output:o) => void
}
interface ModalState<_i,_o> { }

/**
 * @deprecated Don't use directly, use the [[modal]] function instead.
 * @todo maybe change it to `React.FunctionComponent` and hooks, since currently it has not state.
 */
class Modal<i,o> extends React.Component<ModalProps<i,o>, ModalState<i,o>> {
  constructor(props:ModalProps<i,o>, context:any) {
    super(props, context)

    // this.state = { value:props.input } // DEAD CODE
    this.el = document.createElement('div');
  }

  el:HTMLDivElement
  componentDidMount() {
    this.props.modal_root.appendChild(this.el);
  }

  componentWillUnmount() {
    this.props.modal_root.removeChild(this.el);
  }

  render(): React.ReactNode {
    return ReactDOM.createPortal(
      this.props.inner_widget(this.props.input).run(o => this.props.on_done(o)),
      this.el,
    )
  }
}

/**  This is the lifted version of [[modal]]
 * This means instead of operating on a [Widget], it operates on an [[IOWidget]]
 */
export const modal_io = function<i,o>(modal_root_id:string) : (_:IOWidget<i,o>) => IOWidget<i,o> {
  const modal_root = document.getElementById(modal_root_id)!

  return inner_widget => (input:i) => mk_widget({
    run:(on_done:(output:o) => void) =>
      React.createElement<ModalProps<i,o>>(Modal, { on_done, inner_widget, input, modal_root:modal_root })
  })
}

/**
 * It allows you to mount a given `widget` to be rendered in a different place inside the DOM than its parent widget.
 * Underneath it uses the similar in-purpose `ReactDOM.createPortal`.
 * @param modal_root_id 
 */
export const modal = function<o>(modal_root_id:string) : (widget:Widget<o>) => Widget<o> {
  return widget => modal_io<{},o>(modal_root_id)(_ => widget)({})
}
